export default {
    container: {
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
        color: '#fff'
    },
    dialog: {
        position: 'relative',
        margin: '0 auto',
        padding: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        maxWidth: 400,
        height: 'auto',
        color: '#fff',
        lineHeight: 1.3,
        fontFamily: '-apple-system, "Roboto", Helvetica, Arial, sans-serif'
    },
    dialogRow: {
        position: 'relative',
        marginTop: 10
    },
    alignCenter: {
        textAlign: 'center'
    },
    logo: {
        // you need this `width: auto`, otherwise some magic script in the page shell will set the `width` and `height` attribute
        // on the `img` element with the original size
        width: 'auto',
        height: 20
    },
    providerListCol: {
        float: 'left'
    },
    providerList: {
        fontSize: 14,
        width: 200
    },
    continueBtn: {
        height: 30,
        marginTop: 10
    },
    standAlone: {
        maxWidth: 320,
        minWidth: 120,
        background: '#06c',
        border: 0,
        borderRadius: 4,
        color: '#fff',
        position: 'relative',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        padding: '0 15px',
        fontSize: 11,
        width: 180
    },
    clear: {
        clear: 'left'
    }
};



// WEBPACK FOOTER //
// ./app/webapp/syndicated/ProviderDialog/style.js